import React from "react";
import { shouldRenderDiv, addHeaderTagIfMissing } from "../buyingGuideHelpers";
import { BuyingGuideSection } from "../Types/BuyingGuideSection";

export default function BuyingGuideTable({
  section,
  enableHeading,
  defaultHeaderTag,
}: {
  section: BuyingGuideSection;
  enableHeading: boolean;
  defaultHeaderTag: string;
}) {
  const content = section?.contents[0] ?? undefined;

  return (
    <>
      {enableHeading && shouldRenderDiv(section.heading) && (
        <div
          dangerouslySetInnerHTML={{
            __html: addHeaderTagIfMissing(section.heading, defaultHeaderTag),
          }}
        />
      )}
      <div className="table-wrapper">
        <table
          cellPadding="0"
          cellSpacing="0"
          className="table table-bordered table-striped"
        >
          <thead>
            <tr>
              {content?.table.tableData[0]?.map(
                (colName, index) =>
                  shouldRenderDiv(colName) && (
                    <th key={`table-col-${index}`}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: colName,
                        }}
                      />
                    </th>
                  ),
              )}
            </tr>
          </thead>
          <tbody>
            {content?.table.tableData.slice(1).map((row: string[], index) => (
              <tr key={`table-row-${index}`}>
                {row.map(
                  (data, dataindex) =>
                    shouldRenderDiv(data) && (
                      <td key={`table-data-${dataindex}`}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data,
                          }}
                        />
                      </td>
                    ),
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
